import { useState } from 'react';
import { BadgeCheck, Building, Mail, PhoneCallIcon } from 'lucide-react';
import workingconstructor from '@/assets/constructorworking.jpg';
import emailjs from '@emailjs/browser';

export const ContactUS = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.placeholder.toLowerCase()]: e.target.value });
  };

  const handleSend = async () => {
    if (!formData.name || !formData.email || !formData.message) {
      alert('Please fill all required fields.');
      return;
    }

    setStatus('sending');

    const templateParams = {
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
      year: new Date().getFullYear(),
    };

    try {
      await emailjs.send(
        'service_q8hnaxs', // 🔹 Replace with your EmailJS service ID
        'template_61oas47', // 🔹 Replace with your EmailJS template ID
        templateParams,
        'AmbQ-WAMkvA9EFT58' // 🔹 Replace with your EmailJS public key
      );
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('EmailJS Error:', error);
      setStatus('error');
    }
  };

  return (
    <div className="mt-[9rem] flex w-full justify-center bg-[white] py-[4rem] font-inter">
      <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[1rem] gap-y-[3rem] px-[2rem]">
        <div className="flex w-full flex-wrap items-start gap-[2rem]">
          <div className="flex w-full justify-center">
            <BadgeCheck className="h-auto w-[3rem] text-[#e24e1f]" />
          </div>
          <div className="w-full">
            <h1 className="w-full text-center text-[3.2rem] font-[700] leading-[4rem] text-[#121212] lg:text-[4rem] lg:leading-[5.5rem]">
              Building Your Vision
              <br /> With Precision and Trust
            </h1>
            <p className="mt-[1rem] w-full text-center text-[1.6rem] font-[400] text-[#666666]">
              Your vision deserves a foundation built on trust. We manage every detail with
              precision, so you can focus on the outcome.
            </p>
          </div>

          <div className="mt-[3rem] flex w-full flex-wrap items-stretch justify-between gap-y-[2rem]">
            {/* Left Info Card */}
            <div className="relative flex w-full flex-wrap items-start justify-between rounded-[1rem] bg-[#1C253C] px-[2rem] py-[2rem] md:w-[35rem]">
              <img
                alt="workers working"
                className="absolute z-[1] ml-[-2rem] mt-[-2rem] h-full w-full rounded-md object-cover"
                src={workingconstructor}
              />
              <div className="absolute z-[222] ml-[-2rem] mt-[-2rem] h-full w-full rounded-md bg-[rgba(0,0,0,0.4)]"></div>
              <div className="z-[555] mt-[2rem] flex h-full flex-col justify-end gap-[2rem] pb-[4rem]">
                <div className="flex items-center gap-[0.8rem] text-[1.6rem] text-[#FFFFFF]">
                  <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-orange-500">
                    <Building size={'2rem'} className="text-white" />
                  </div>
                  <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[600]">
                    125A Crossbrook Street, Cheshunt, Hertfordshire, United Kingdom, EN8 8LY
                  </p>
                </div>
                <div className="flex items-center gap-[0.8rem] text-[1.6rem] text-[#FFFFFF]">
                  <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-orange-500">
                    <Mail size={'2rem'} className="text-white" />
                  </div>
                  <p className="w-[calc(100%-4rem)] text-[1.6rem] font-[600]">
                    {' '}
                    office@kucontractors.com
                  </p>
                </div>

                <div className="flex items-center gap-[0.8rem] text-[1.6rem] text-[#FFFFFF]">
                  <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-orange-500">
                    <PhoneCallIcon size={'2rem'} className="text-white" />
                  </div>
                  <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[600]">07454-926-222</p>
                </div>
              </div>
            </div>

            {/* Form Section */}
            <div className="flex w-full flex-wrap items-start justify-between rounded-[1rem] px-[1rem] py-[2rem] md:w-[calc(100%-35rem)]">
              <div className="flex w-full flex-row flex-wrap items-center justify-between gap-y-[2rem]">
                <input
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="border-footer-emailboxborder text-footer-bottom-header-content h-none w-[48%] appearance-none rounded-md border-[1px] bg-transparent px-[1rem] py-[1.5rem] text-[1.6rem] outline-none"
                />
                <input
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="border-footer-emailboxborder text-footer-bottom-header-content h-none w-[48%] appearance-none rounded-md border-[1px] bg-transparent px-[1rem] py-[1.5rem] text-[1.6rem] outline-none"
                />
                <input
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="border-footer-emailboxborder text-footer-bottom-header-content h-none w-full appearance-none rounded-md border-[1px] bg-transparent px-[1rem] py-[1.5rem] text-[1.6rem] outline-none"
                />
                <textarea
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="border-footer-emailboxborder text-footer-bottom-header-content h-none mt-[1.5rem] h-[15rem] w-full appearance-none rounded-md border-[1px] bg-transparent px-[1rem] py-[1.5rem] text-[1.6rem] outline-none"
                />
                <div
                  onClick={status !== 'sending' ? handleSend : undefined}
                  className={`relative mt-[3rem] w-full cursor-pointer rounded-md ${
                    status === 'success'
                      ? 'bg-green-500'
                      : status === 'error'
                        ? 'bg-red-500'
                        : 'bg-[#e24e1f]'
                  } pb-[1.5rem] pt-[1.5rem] transition-all duration-300 md:mt-[5.3rem]`}
                >
                  <h1 className="w-full text-center text-[1.6rem] font-[600] text-white md:text-[1.8rem]">
                    {status === 'sending'
                      ? 'Sending...'
                      : status === 'success'
                        ? 'Message Sent!'
                        : status === 'error'
                          ? 'Error! Try Again'
                          : 'Let’s Talk'}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
